import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/organization',
  component: Layout,
  name: 'Organization',
  meta: {
    title: '组织管理',
    icon: 'i-ant-design:team-outlined',
  },
  children: [
    {
      path: 'user',
      name: 'OrganizationUser',
      component: () => import('@/views/organization/user/index.vue'),
      meta: {
        title: '员工管理',
        icon: 'i-ant-design:user-outlined',
        auth: 'organization:user:list',
      },
    },
  ],
}

export default routes
